import React from 'react';
import { ClockIcon, BrainIcon, TrendingDownIcon, TrophyIcon, ArrowDownIcon } from 'lucide-react';
const points = [{
  icon: ClockIcon,
  title: 'El domingo es un peso',
  text: 'Sientes ansiedad por no saber qué ejercicios proponer el lunes.'
}, {
  icon: BrainIcon,
  title: 'Carga mental post-trabajo',
  text: 'Llegas de tu empleo y aún tienes que diseñar la sesión de la noche.'
}, {
  icon: TrendingDownIcon,
  title: 'Te faltan herramientas',
  text: 'Sientes que tus jugadores se estancan y no sabes cómo llevarlos al siguiente nivel técnico.'
}, {
  icon: TrophyIcon,
  title: 'Buscas profesionalismo',
  text: 'Quieres que tu staff y tu club te vean como un coach moderno, organizado y de resultados.'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 sm:py-28 px-4 relative overflow-hidden" data-id="element-273">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-274"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-secondary/5 rounded-full blur-[120px] pointer-events-none" data-id="element-275"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-276">
        {/* Eyebrow with decorative lines */}
        <div className="flex items-center justify-center gap-3 mb-5" data-id="element-277">
          <span className="h-px w-8 sm:w-12 bg-gradient-to-r from-transparent to-primary/60" data-id="element-278"></span>
          <p className="text-primary font-bold text-sm sm:text-base tracking-[0.2em] uppercase whitespace-nowrap" data-id="element-279">
            👀 ¿Te suena familiar?
          </p>
          <span className="h-px w-8 sm:w-12 bg-gradient-to-l from-transparent to-primary/60" data-id="element-280"></span>
        </div>

        <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-3 text-center tracking-tight leading-tight" data-id="element-281">
          MegaPack Rugby Listo es para ti{' '}
          <span className="relative inline-block" data-id="element-282">
            <span className="relative z-10 text-primary" data-id="element-283">si:</span>
            <span className="absolute bottom-1 left-0 right-0 h-2 sm:h-3 bg-primary/20 -z-0 rounded-sm" data-id="element-284"></span>
          </span>
        </h2>
        <p className="text-text-sec text-center text-base sm:text-lg mb-12 sm:mb-14 max-w-xl mx-auto" data-id="element-285">
          Si asientes con la cabeza en alguna de estas situaciones, este pack
          fue diseñado para vos.
        </p>

        <div className="space-y-4 sm:space-y-5" data-id="element-286">
          {points.map((point, i) => {
          const Icon = point.icon;
          const num = String(i + 1).padStart(2, '0');
          return <div key={i} className="group relative flex items-start gap-4 sm:gap-6 bg-bg-alt/70 backdrop-blur-sm rounded-2xl p-5 sm:p-7 border border-border-light hover:border-primary/60 transition-all duration-300 shadow-lg hover:shadow-[0_8px_30px_rgba(59,130,246,0.15)] hover:-translate-y-0.5 overflow-hidden" data-id="element-287">
                {/* Hover accent bar */}
                <span className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-primary to-primary/40 scale-y-0 group-hover:scale-y-100 origin-top transition-transform duration-300" data-id="element-288"></span>

                {/* Number + Icon stack */}
                <div className="flex flex-col items-center gap-2 flex-shrink-0" data-id="element-289">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-primary/10 flex items-center justify-center border border-primary/20 group-hover:bg-primary group-hover:border-primary transition-all duration-300 shadow-[0_0_15px_rgba(59,130,246,0.15)] group-hover:shadow-[0_0_25px_rgba(59,130,246,0.4)]" data-id="element-290">
                    <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-primary group-hover:text-white transition-colors" strokeWidth={2.2} data-id="element-291" />
                  </div>
                  <span className="text-[10px] sm:text-xs font-black text-text-sec/60 group-hover:text-primary tracking-wider transition-colors" data-id="element-292">
                    {num}
                  </span>
                </div>

                <div className="flex-1 pt-0.5" data-id="element-293">
                  <h3 className="text-text-main font-black text-lg sm:text-xl mb-1.5 tracking-tight" data-id="element-294">
                    {point.title}
                  </h3>
                  <p className="text-text-sec text-base sm:text-lg leading-relaxed" data-id="element-295">
                    {point.text}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Closing emotional hook → CTA */}
        <div className="mt-12 sm:mt-14 text-center" data-id="element-296">
          <p className="text-text-main text-lg sm:text-xl font-bold mb-4" data-id="element-297">
            Si te identificaste con{' '}
            <span className="text-primary" data-id="element-298">2 o más</span>...
          </p>
          <a href="#pricing" className="inline-flex items-center gap-2 text-cta-green hover:text-cta-green-hover font-black text-base sm:text-lg group transition-colors" data-id="element-299">
            Esto es exactamente lo que necesitas
            <ArrowDownIcon className="w-5 h-5 group-hover:translate-y-1 transition-transform" data-id="element-300" />
          </a>
        </div>
      </div>
    </section>;
}